<template>
  <div>
    <div v-if="isMp4" class="vt-holder">
      <video-player :url="vidUrl" autoplay  />
    </div>
    <div class="yt-holder" v-if="isYouTube" >
      <you-tube-player :url="externalUrl" autoplay />
    </div>
    <div class="yt-holder" v-if="isVimeo" :class="{inpage: inpage}">
      <vimeo-player :url="externalUrl" autoplay />
    </div>
  </div>
</template>

<script>
import vp from '@/utils/video-parser.js'
import VideoPlayer from '@/components/video/VideoPlayer.vue'
import VimeoPlayer from '@/components/video/VimeoPlayer.vue'
import YouTubePlayer from '@/components/video/YouTubePlayer.vue'

export default {
  components: {
    VideoPlayer,
    VimeoPlayer,
    YouTubePlayer
  },
  props: {
    videoUrl: String,
    externalUrl: String
  },
  data () {
    return {
      isMp4: false,
      isYouTube: false,
      isVimeo: false,
      vidUrl: ''
    }
  },
  created () {
    this.init ()
  },
  methods: {
    init () {
      if(this.externalUrl) {
        console.log('has external url', this.externalUrl)
        this.isMp4 = false
        this.isYouTube = vp.isYouTube(this.externalUrl)
        this.isVimeo = vp.isVimeo(this.externalUrl)
      }
      else {
        if(this.videoUrl) {
          console.log('has video url', this.videoUrl)
          let fv = this.videoUrl
          let vu = this.videoUrl.toLowerCase()
          if((vu.endsWith('.m4v'))|| (vu.endsWith('.flv')) || (vu.endsWith('.mov'))) {
            fv += '.mp4'
            this.isMp4 = true
          }
          if(vu.endsWith('.mp4')) {
            this.isMp4 = true
          }
          this.vidUrl = fv
          console.log('vmulti url', this.vidUrl)
        }
      }
    }
  },
  watch: {
    videoUrl () {
      this.init ()
    },
    externalUrl () {
      this.init ()
    }
  }

}
</script>

<style>
.vt-holder{
  width:100%;
}

.vt-holder .zoomed-video{
  width:100%;
}
</style>